import moment from 'moment';
export const TODAY = moment();
export const UNSCHEDULED = 'unscheduled';
export const LANE_WIDTH = 280;
export const PLANNER_CONTAINER_LEFT_MARGIN = 25;
export const WEEK_FETCH_OFFSET = 5;
export const WEEK_FETCH_AHEAD_OFFSET = 10;
export const WAYPOINT_DISTANCE = '-1500px';
export const NO_PROJECT = 'No Project';
